import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {isEmpty} from 'lodash';
import styled from 'styled-components';
import * as actions from '../../../store/actions';
import { i18n } from '../../../translate/i18n';
import {
  Typography, IconButton, FormControl, FormControlLabel, Switch
} from '@mui/material';
import {withRouter} from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import Spinner from '../../../components/Spinner/index'

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../Forms/styles';

import Autocomplete from '../../../UI/Autocomplete/Autocomplete';

const ModalCloneEquipmentModel = (props) => {
  const dispatch = useDispatch();

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState('name');
  const [order, setOrder] = useState('asc');

	const [serviceTypesError, setServiceTypesError] = useState(false);
  const [frequencyError, setFrequencyError] = useState(false);

  // selected values on autocomplete
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState([]);

  const [searchTextServiceTypes, setSearchTextServiceTypes] = useState('');
  const [searchTextFrequency, setSearchTextFrequency] = useState('');

  const [serviceTypesFormated, setServiceTypesFormated] = useState({});
  const [frequencyFormated, setFrequencyFormated] = useState({});

  const [mandatory, setMandatory] = useState(true);

  const postCloneChecklist = (body, equipmentId, siteId, id) =>
    dispatch(actions.postCloneChecklist(body, equipmentId, siteId, id));

  const fetchServiceTypes = useCallback(
    () => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy)),
    [page, limit, searchTextServiceTypes, order, orderBy]
  );

  const fetchFrequency = useCallback(
		() => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy, selectedServiceTypes ? selectedServiceTypes.value : '')),
    [page, limit, searchTextFrequency, order, orderBy, selectedServiceTypes]
  );

  const serviceTypes = useSelector((state) => state.serviceTypes.serviceTypes);
  const frequencies = useSelector((state) => state.frequency.frequencies);

  const loadingServiceTypes = useSelector((state) => state.serviceTypes.loading);
  const loadingFrequency = useSelector((state) => state.frequency.loading);
  const loadingChecklistClone = useSelector((state) => state.equipmentModels.loadingChecklistClone);
  const selectedSites = useSelector(state => state.sites.selectedSitesQuestions);

  // FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = serviceTypes;
    const returnArray = [];
    dataFromRedux.rows.map((dt) =>
      returnArray.push({value: dt._id, label: dt.name})
    );
    setServiceTypesFormated(returnArray);
  }, [serviceTypes]);

  useEffect(() => {
    const dataFromRedux = frequencies;
    const returnArray = [];
    dataFromRedux.rows.map((dt) =>
      returnArray.push({value: dt._id, label: dt.name})
    );
    setFrequencyFormated(returnArray);
  }, [frequencies]);

  useEffect(() => {
    fetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy);
  }, [searchTextServiceTypes]);

  useEffect(() => {
    fetchFrequency(page, limit, searchTextFrequency, order, orderBy);
  }, [searchTextFrequency]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (isEmpty(selectedServiceTypes)) {
      setServiceTypesError(true);
      hasError = true;
    }

    if (isEmpty(selectedFrequency)) {
      setFrequencyError(true);
      hasError = true;
    }

    if (hasError) return;

    const body = {
      serviceType: selectedServiceTypes.value,
      frequency: selectedFrequency.value,
      mandatory
    };
    
		postCloneChecklist(body, props.equipmentModel._id, selectedSites[0]._id, props.modalContent._id).then((result) => {
			if (result !== 'error') {
        props.closeModal(false, '');        
        dispatch(actions.postCloneChecklist);
			}
		});
  };

  const handleInputChangeSelectorServiceTypes = (text) => {
    setSearchTextServiceTypes(text);
  };

  const handleInputChangeServiceTypes = (selected) => {
    setServiceTypesError(false);
    setSelectedServiceTypes(selected);
  };

  const handleInputChangeSelectorFrequency = (text) => {
    setSearchTextFrequency(text);
  };

  const handleInputChangeFrequency = (selected) => {
    setFrequencyError(false);
    setSelectedFrequency(selected);
  };

  return <>
    <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loadingChecklistClone ? '0.3' : '1' }}>
              {loadingChecklistClone && <Spinner overlay />}
              <DivFormTitle>
                  <Typography variant="h6">
                      {i18n.t('typographyModalCloneCheckbox.text')}
                  </Typography>

              </DivFormTitle>

              {props.modalContent &&
                  <div style={{ margin: '1rem 0' }}>
                      {i18n.t('divModalCloneCheck.text1')} <b>{props.modalContent.serviceType.name} / {props.modalContent.frequency.name}</b> {i18n.t('divModalCloneCheck.text2')}
                  </div>}

          {
            (selectedSites && selectedSites.length > 0) && 
            <div style={{color: 'red'}}>{`* Apenas serão clonadas questões do site: ${selectedSites[0].name}`}</div>
          }

              <FormControl variant="standard" fullWidth margin="normal" required>
                  <Autocomplete
                      loading={loadingServiceTypes} // sent to isLoading
                      label={i18n.t('autocompleteModalCloneCheck.serviceType')}
                      data={serviceTypesFormated} // sent to options
                      onSelectValue={handleInputChangeServiceTypes} // sent to onChange
                      valueSelected={selectedServiceTypes} // sent to value
                      newSearchText={handleInputChangeSelectorServiceTypes}
                      name="serviceType"
                      hasError={serviceTypesError}
                  />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="normal" required>
                  <Autocomplete
                      loading={loadingFrequency} // sent to isLoading
                      label={i18n.t('autocompleteModalCloneCheck.frequency')}
                      data={frequencyFormated} // sent to options
                      onSelectValue={handleInputChangeFrequency} // sent to onChange
                      valueSelected={selectedFrequency} // sent to value
                      newSearchText={handleInputChangeSelectorFrequency}
                      name="frequency"
                      hasError={frequencyError}
                  />
              </FormControl>
      <FormControlLabel
        style={{marginBottom: 30, marginTop: 20}}
        control={<Switch checked={mandatory} onChange={e => setMandatory(e.target.checked)} />}
        label={i18n.t('autocompleteModalCloneCheck.mandatory')}
      />
              <DivSubmitButtons>
                  <IconButton onClick={() => props.closeModal()} size="large">
                      <CloseIcon fontSize="large" color="error" />
                  </IconButton>
                  <IconButton type="submit" size="large">
                      <DoneIconStyled fontSize="large" />
                  </IconButton>
              </DivSubmitButtons>
      </FormStyled>

  </>;
};

export default withRouter(ModalCloneEquipmentModel);

const TypographyHover = styled(Typography)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const styles = {
	opacityContainer: {
		position: 'relative',
	},
	groupContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	icon: {
		marginLeft: 5,
		cursor: 'pointer',
		fontSize: '1.5rem',
	},
	groupLabel: {
		fontWeight: 'bold',
	},
	createButton: {
		marginLeft: 20,
		background: '#bbd2ca',
		border: 'none',
		fontSize: 11,
		fontWeight: 400,
		borderRadius: 15,
		padding: '5px 10px 5px 10px',
		cursor: 'pointer',
	}
};
